/* eslint max-lines: off */
import '../../modules/module.review.main';
import ReportLayer from './ReportLayer';
import PreviewLayer from './PreviewLayer';
import SelectReviewOptionFilterLayer from './SelectReviewOptionFilterLayer';
import Paginate from '../paginate/Paginate';
import throttle from '../../app/Helper/throttle';
/**
 * word 의 마지막 글자가 받침을 가지는지 여부 확인
 * @param sWord
 * @returns {boolean}
 */
function hasFinalConsonant(sWord) {
  return (sWord.charCodeAt(sWord.length - 1) - 0xac00) % 28 > 0;
}

/**
 * 키워드를 기반으로 유저뷰에 출력되는 문구 조회
 * : 유저뷰에는 ‘(질문키워드)는(은) 어떤가요?’로 텍스트가 조합되어 출력
 * @param {string} sKeyword 질문 키워드
 * @returns {string}
 */
function getPreviewQuestionHtml(sKeyword) {
  if (!sKeyword) {
    return '';
  }

  let sPostposition = '는';
  if (hasFinalConsonant(sKeyword)) {
    sPostposition = '은';
  }

  return `<span className='notice'>${sKeyword}</span>${sPostposition} 어떤가요?`;
}

export default class Review {
  constructor() {
    // reviewType이 N일 경우 리뷰를 노출하지 않는다.
    if (TMON.oApp.htStorage.reviewType.data === 'N') {
      return;
    }

    this.io = null;
    this.bWrapperRender = false;

    // 포토리뷰 슬라이더에서 보여줄 이미지 갯수
    this.PHOTOREVIEW_SLIDE_IMAGE_COUNT = 4;
    if (TMON.oApp.sPlatform === 'PW') {
      this.PHOTOREVIEW_SLIDE_IMAGE_COUNT = 5;
    }

    this.PHOTOREVIEW_NEXT_PAGE_MARGIN_COUNT = 4; // 앞으로 N개의 리뷰가 남았을때 다음 데어터를 호출

    this.nPhotoSlideIndex = 0;
    this.bOnGetNextPhotoReview = false;

    this.htFilterOption = {};
    this.aSelectedOption = [];
    this.nCurrentDepth = 0;

    // SC카테고리 모아보기
    this.bShowSCReviewChecked = TMON.htStaticData.htDealInfo.isScDeal;
    this.sCurrentState = '';

    this.removeDuplicatedReview(true);
    this.initPhotoReview();
    this.initReview();
  }

  initReview() {
    if (TMON.oApp.sPlatform === 'PW') {
      this.COUNT_PAGE_ON_BLOCK = 10;
      this.COUNT_PER_PAGE = 20;

      this.bUsePaginate = true;
      this.sPaginateId = 'reviewPaginate';

      this.getReviewByPage(1);
    } else {
      this.FIRST_REVIEW_COUNT = 5; // 최초로 보여지는 리뷰의 갯수
      this.COUNT_PER_PAGE = 20; // 리뷰를 요청할 때 몇 개씩 받을지

      this.nPage = 0; // 현재 몇 페이지인지
      this.nCount = 0; // 응답으로 받은 갯수

      this.getReview(true);
    }
  }

  /**
   * 포토리뷰 모듈 초기화
   */
  initPhotoReview() {
    this.nPhotoReviewPage = 1; // 현제 포토 리뷰 데이터 페이지
    this.welTopBtn = $('#_naviToTop');
    TMON.oModuleReview.init({
      welContainer: $('#view-default-scene-review-init'), // {jQuery Object} HTML이 들어갈 컨테이너,
      sType: TMON.sDevice === 'PW' ? 'REVIEW' : 'LIST', // 'REVIEW' 리뷰상세보기, 'LIST' 포토리스트, 'MODIFY' 리뷰 수정하기, 'WRITE' 리뷰 쓰기
      bUseSlider: TMON.sDevice !== 'PW', // 리뷰상세 보기에서 다음 리뷰로 넘길 때 슬라이더를 사용할것인지? (* PC 또는 단일리뷰를 보여주고 싶을 때 false로 둔다.)
      bUseHashEvent: true, // 해쉬로 모드 전환(view, modify, write 등) 가능하게 할것 인가?
      bShowModifyButtons: true, // 리뷰 삭제, 수정 버튼 노출 여부(모바일의 경우만 해당)
      aReviewList: TMON.oApp.htStorage.photoReviewList.data.list, // {Array} 리뷰 리스트 데이터 (없으면 비워둬도 된다)
      onGetNextData: () => {
        // 다음 데이터를 가져온다.
        this.getNextPhotoReviewData();
      },
      onRecommend: (nReviewNo, bAlreadyRecommended, sMemberNo) => {
        // 추천하기시
        TMON.oApp.setStorageAction('sendGAByParam', {
          sTlArea: 'PCI0',
          sTlOrd: '12',
        });
        this.nRecommendReviewNo = nReviewNo;
        if (bAlreadyRecommended) {
          // 이미 추천한 리뷰
          this.cancelRecommendationReview(nReviewNo);
          return;
        }
        this.recommendationReview(nReviewNo, sMemberNo);
      },
      onReport: nReviewNo => {
        // 신고하기
        TMON.oApp.setStorageAction('sendGAByParam', {
          sTlArea: 'PCI0',
          sTlOrd: '11',
        });
        this.openReportReviewLayerFromPhotoReview(nReviewNo);
      },
      onShow: sType => {
        // 포토리뷰가 보여질 떄
        if (sType === 'review') {
          // 리뷰 상세일 경우만 top 버튼을 숨긴다.
          this.hideGoTopBtn();
        } else {
          this.showGoTopBtn();
        }
      },
      onHide: () => {
        // 포토리뷰가 숨겨질 때
        this.showGoTopBtn();
      },
      onAfterDeleteLastData: () => {
        // 마지막 리뷰가 삭제되었을 경우
        window.history.back();
        this.showGoTopBtn();
      },
      onClickNextReview: () => {
        // PC의 다음 슬라이드 버튼 클릭시
        TMON.oApp.setStorageAction('sendGAByParam', {
          sTlArea: 'PCI0',
          sTlOrd: '16',
        });
      },
      onClickPrevReview: () => {
        // PC의 이전 슬라이드 버튼 클릭시
        TMON.oApp.setStorageAction('sendGAByParam', {
          sTlArea: 'PCI0',
          sTlOrd: '15',
        });
      },
      onClickShowOption: () => {
        // 옵션 펼치기 버튼 클릭시
        TMON.oApp.setStorageAction('sendGAByParam', {
          sTlArea: 'PCI0',
          sTlOrd: '10',
        });
      },
      onClickPhotoInList: () => {
        // 포토리스트에서 포토 클릭
        TMON.oApp.setStorageAction('sendGAByParam', {
          sTlArea: 'PCI0',
          sTlOrd: '9',
        });
      },
      onUpdateReview: htReview => {
        // 리뷰 수정후 업데이트
        // 데이터의 key 이름이 조금씩 달라서 수정해줘야한다.
        let htRefinedData = Object.assign(htReview, {
          reviewSrl: htReview.reviewNo,
          imageUseYn: 'N',
          ownArticle: htReview.isOwner,
        });

        if (htReview.hasImage) {
          htRefinedData = Object.assign(htRefinedData, {
            imageUseYn: 'Y',
            imageList: htReview.imageInfo.image.map(sImage =>
              /^http/.test(sImage)
                ? sImage.substring(sImage.indexOf('/cdn'))
                : sImage
            ),
          });
        }
        this.updateReviewItem(htRefinedData);
        this.reloadPhotoReviewList();
      },
      onCloseReview: () => {
        history.back();
      },
      onDelete: (nMainBuyNo, nMainDealNo, nMemberNo, nReviewNo) => {
        // 삭제하기
        this.deleteReview(nMainBuyNo, nMainDealNo, nMemberNo, nReviewNo);
      },
      onModifyFileUploadNotSupportApp: sMainBuySrl => {
        // 파일 업로드를 지원하지 않는 구앱버전에서 기존 URL 이동으로 대체
        this.showReviewModifyPHPPage(sMainBuySrl);
      },
    });
  }

  showGoTopBtn() {
    if (TMON.sDevice !== 'PW') {
      TMON.app.callApp(
        'webview',
        'setWebProperties',
        '{"bShowGoTopButton": true}'
      );
    }
    this.welTopBtn.removeClass('blind');
  }

  hideGoTopBtn() {
    if (TMON.sDevice !== 'PW') {
      TMON.app.callApp(
        'webview',
        'setWebProperties',
        '{"bShowGoTopButton": false}'
      );
    }
    this.welTopBtn.addClass('blind');
  }

  deleteReview(nMainBuyNo, nMainDealNo, nMemberNo, nReviewNo) {
    if (!window.confirm('리뷰를 삭제하시겠습니까?')) {
      return;
    }
    this.nDeleteReviewNo = nReviewNo;
    TMON.oApp.oApi.fetchApi('deleteReview', {
      nMainBuyNo,
      nMainDealNo,
      nMemberNo,
    });
  }

  deleteReviewAction() {
    const { httpCode, data = {} } = TMON.oApp.getStorage().deleteReview;
    const isError = httpCode !== 200 || !data.result;

    if (isError) {
      alert(data.message || '리뷰 삭제에 실패했습니다. 다시 시도해 주세요.');
    } else {
      this.removeReviewFromView(this.nDeleteReviewNo);
      this.reloadPhotoReviewList();
    }
  }

  removeReviewFromView(nReviewNo) {
    $('#_reviewList')
      .find(`[data-reviewsrl=${nReviewNo}]`)
      .remove();
  }

  /**
   * 리뷰 수정 후 업데이트 한다.
   * @param htReview
   */
  updateReviewItem(htReview) {
    const sHtml = this.getRenderedReviewHtml([htReview]);
    const welOldReview = $('#_reviewWrap').find(
      `[data-reviewsrl=${htReview.reviewNo}]`
    );

    if (welOldReview.length === 0) {
      return;
    }
    welOldReview.replaceWith(sHtml);
    $('#_reviewWrap')
      .find(`[data-reviewsrl=${htReview.reviewNo}] div.txt_area`)
      .prepend(welOldReview.find('._optionList'));
  }

  /**
   * 구매후기 추천(추천취소가능, 포토리뷰에서 사용)
   * @param sReviewSrl
   */
  recommendationReview(sReviewSrl, sMemberSrl) {
    if (!TMON.bLogin) {
      localStorage.setItem('FIRST_REVIEW_ACTION_SERIAL', sReviewSrl); // 포토 리뷰 리스트에 첫번째로 와야할 리뷰번호(보고있던 리뷰에서 로그인 등으로 다른페이지 왔다가 온 경우 보고있던 리뷰를 바로 보여주기 위해 사용)

      this.setPagingToLocalStorage();
      TMON.oApp.oUtil.login();
    } else if (TMON.memberNo === sMemberSrl) {
      this.showRejectMessageForOwner(true);
    } else {
      TMON.oApp.oApi.fetchApi('recommendationReview', {
        sReviewSrl,
        sMemberSrl,
      });
    }
  }

  /**
   * 구매후기 추천을 취소한다.
   * @param sReviewSrl
   */
  cancelRecommendationReview(sReviewSrl) {
    if (!TMON.oModuleReview.getIsShow()) {
      this.cancelRecommendReview(sReviewSrl);
      return;
    }

    if (!TMON.bLogin) {
      this.setPagingToLocalStorage();
      TMON.oApp.oUtil.login();
    } else {
      TMON.oApp.oApi.fetchApi('cancelRecommendationReview', { sReviewSrl });
    }
  }

  cbRecommendationReview(bIsCancelRecommend) {
    if (!TMON.oModuleReview.getIsShow()) {
      this.cbCancelRecommendReview();
      return;
    }

    const htData = bIsCancelRecommend
      ? TMON.oApp.htStorage.cancelRecommendationReview
      : TMON.oApp.htStorage.recommendationReview;
    const nRecommendCount = htData.data;

    if (htData.responseJSON && htData.responseJSON.exceptionMessage) {
      alert(htData.responseJSON.exceptionMessage);
      return;
    }

    try {
      if (nRecommendCount !== undefined) {
        const commonInput = [
          this.nRecommendReviewNo,
          nRecommendCount,
          bIsCancelRecommend,
        ];

        TMON.oModuleReview.afterRecommend(...commonInput);
        this.showRecommendToast(bIsCancelRecommend);
        this.updateRecommendCount(...commonInput);
      }
    } catch (e) {
      console.error(e);
    }
  }

  showRecommendToast(bIsCancelRecommend) {
    // Mobile의 경우에는 추천 토스트팝업을 포토리뷰 모듈에서 처리한다.
    if (TMON.sDevice !== 'PW') {
      return;
    }

    if (bIsCancelRecommend) {
      TMON.oApp.setStorage('toast', '추천이 취소되었습니다');
    } else {
      TMON.oApp.setStorage('toast', '추천해 주셔서 감사합니다');
    }
  }

  getNextPhotoReviewData() {
    if (TMON.oApp.htStorage.photoReviewList.data.nextEntity === false) {
      // 다음 페이지 데이터가 없으면..
      return;
    }

    if (this.bOnGetNextPhotoReview) {
      // 데이터를 요청 중이면
      return;
    }

    this.bOnGetNextPhotoReview = true;

    // 다음 페이지 데이터를 가져온다.
    this.nPhotoReviewPage += 1;
    TMON.oApp.oApi.fetchApi('photoReviewList', {
      nPage: this.nPhotoReviewPage,
      bShowSCReview: this.bShowSCReviewChecked,
    });
  }

  onClickSCReview(e) {
    this.bShowSCReviewChecked = !this.bShowSCReviewChecked;

    // 데이터 불러 오기 전에 클릭시 재호출 되는 걸 방지
    const welCurrentTarget = $(e.currentTarget);
    welCurrentTarget.attr('disabled', true);

    // 초기화
    this.nPage = 0;
    this.nCount = 0;

    // 포토 리뷰만 보기
    this.htFilterOption.flagImage = null;

    // 정렬 타입
    this.htFilterOption.sortKey = null;

    // 필터
    this.aSelectedOption = [];
    this.htFilterOption.tmpOptionDealNo = null;
    this.htFilterOption.optionDealNo = null;

    this.sCurrentState = 'SCReview';

    // API 호출
    TMON.oApp.oApi.fetchApi('photoReviewImageCount', {
      bShowSCReview: this.bShowSCReviewChecked,
    });

    this.reloadPhotoReviewList();

    // TL sendLog
    const {
      htStaticData: {
        htDealInfo: { dealNo },
      },
    } = TMON.oApp.htStorage;
    const status = this.bShowSCReviewChecked ? 'on' : 'off';

    TMON.sendLog(null, [
      e.currentTarget,
      e,
      {
        'tl:area': 'DCRSSC',
        'tl:ord': '',
        'tl:dimension': `main_deal_srl:${dealNo}__status:${status}`,
      },
    ]);
  }

  /**
   * 동일 상품리뷰 모아보기
   */
  cbSCReview() {
    if (TMON.oApp.sPlatform === 'PW') {
      this.getReviewByPage(1);
    } else {
      this.getReview(true);
    }
  }

  /**
   * 포토리뷰 데이터를 다시 가져온다.
   */
  reloadPhotoReviewList() {
    TMON.oModuleReview.resetData();
    this.nPhotoReviewPage = 1;
    $('#_reviewWrap [data-role=photoReviewListWrap]').html('');
    TMON.oApp.oApi.fetchApi('photoReviewList', {
      nPage: this.nPhotoReviewPage,
      bShowSCReview: this.bShowSCReviewChecked,
    });
  }

  /**
   * 포토리뷰 이미지 슬라이더를 업데이트 한다.
   */
  updatePhotoReviewList() {
    TMON.oModuleReview.addData(TMON.oApp.htStorage.photoReviewList.data.list);
    if (TMON.sDevice === 'PW') {
      $('#_reviewWrap [data-role=photoReviewListWrap]').append(
        this.getPhotoReviewSliderHtml(true)
      );
    } else {
      $('#_reviewWrap [data-role=photoReviewListWrap]')
        .html('')
        .append(this.getPhotoReviewSliderHtml(false));
    }
    this.updatePhotoReviewSlideBtnStatus();
  }

  update(sStorageKey) {
    if (sStorageKey === 'reviewList') {
      if (!this.bWrapperRender) {
        this.bWrapperRender = true;
        this.render();
        this.setEvent();
        this.afterLoginAction();
      }

      if (this.sCurrentState === 'SCReview') {
        this.render();
        this.sCurrentState = '';
      }

      this.setReview();
      this.updatePaginate();
    } else if (sStorageKey === 'recommendReview') {
      this.cbRecommendReview();
    } else if (sStorageKey === 'recommendationReview') {
      this.cbRecommendationReview(false);
    } else if (sStorageKey === 'cancelRecommendationReview') {
      this.cbRecommendationReview(true);
    } else if (sStorageKey === 'reportReview') {
      this.cbReportReview();
    } else if (sStorageKey === 'photoReviewList') {
      if (this.sCurrentState === 'SCReview') {
        this.cbSCReview();
      }

      this.bOnGetNextPhotoReview = false;
      this.removeDuplicatedReview(false);
      this.updatePhotoReviewList();
    } else if (sStorageKey === 'deleteReview') {
      this.deleteReviewAction();
    } else if (sStorageKey === 'login') {
      this.afterLoginAction();
    }

    this.clearLocalStorage();
  }

  /**
   * 티몬 홈에서 '베스트포토리뷰' 링크 타고 오는경우 해당 리뷰가 가장 상단으로 복사되어서 보내주므로, 중복되는 리뷰는 제거해야한다.
   */
  removeDuplicatedReview(bIsFirstList) {
    let nFirstReviewNo = parseInt(
      localStorage.getItem('FIRST_REVIEW_ACTION_SERIAL'),
      10
    ); // 리뷰 상세보기중에 로그인한 경우 보고 있는 리뷰를 최상단으로 올리기위해 사용한 리뷰를 중복 제거한다.

    if (TMON.util.getHashJSON().firstReviewNo) {
      nFirstReviewNo = parseInt(TMON.util.getHashJSON().firstReviewNo, 10); // 베스트 포토 리뷰의 리뷰번호
    }

    if (!nFirstReviewNo) {
      return;
    }

    let nMatchIndex = null;
    for (
      let i = 0;
      i < TMON.oApp.htStorage.photoReviewList.data.list.length;
      i += 1
    ) {
      if (
        !(bIsFirstList === true && i === 0) &&
        TMON.oApp.htStorage.photoReviewList.data.list[i].reviewNo ===
          nFirstReviewNo
      ) {
        nMatchIndex = i;
        break;
      }
    }

    if (nMatchIndex !== null) {
      TMON.oApp.htStorage.photoReviewList.data.list.splice(nMatchIndex, 1);
    }
  }

  setEvent() {
    const welBody = $('body');
    const welContainer = $('#_reviewWrap');
    welContainer.on('click', '.btn_review_wide', this.openReviewSurvey); // 사용 만족도 자세히 보기
    welContainer.on('click', '.close', e => {
      this.toggleOption(e);
    }); // 옵션 더보기 버튼
    welContainer.on('click', '[data-role=moveToBuylist]', e => {
      this.moveToBuylist(e);
    }); // 리뷰 쓰기 버튼
    welContainer.on('click', '[data-role=recommendReview]', e => {
      const currentTarget = $(e.currentTarget);
      const sReviewSrl = currentTarget.attr('data-reviewsrl');
      const sMemberlSrl = currentTarget.attr('data-membersrl');

      if (currentTarget.hasClass('on')) {
        this.cancelRecommendationReview(sReviewSrl);
      } else {
        this.recommendReview(sReviewSrl, sMemberlSrl);
      }
    }); // 리뷰 추천하기
    welContainer.on('click', '[data-role=reportReview]', e => {
      this.openReportReviewLayer($(e.currentTarget).attr('data-reviewsrl'));
    }); // 리뷰 신고하기
    welContainer.on('click', '[data-role=callPreview]', e => {
      this.callPreview(e);
    }); // 리뷰 이미지 미리보기
    welContainer.on('click', '[data-role=modifyReview]', e =>
      this.onClickModifyReview(e)
    ); // 리뷰 수정하기
    welContainer.on('click', '[data-role=deleteReview]', e => {
      this.onClickDeleteReview(e);
    }); // 리뷰 삭제하기
    welContainer.on('click', '[data-role=prevPhotoReviewImage]', () => {
      this.onClickPrevPhotoReviewImage();
    }); // 이전 포토리뷰 이미지
    welContainer.on('click', '[data-role=nextPhotoReviewImage]', () => {
      this.onClickNextPhotoReviewImage();
    }); // 다음 포토리뷰 이미지
    welContainer.on('click', '[data-role=showReviewDetail]', e => {
      this.onClickViewPhotoReview(e);
    }); // 포토리뷰 보기
    welContainer.on('click', '#_showOnlyPhotoReview', e => {
      this.onClickShowOnlyPhotoReview(e);
    }); // 포토리뷰만 보기 아이콘
    welContainer.on('click', '.option_select_area', e => {
      this.onClickShowOptionFilterLayer(e);
    }); // 모바일 옵션 필터 레이어 열기
    welContainer.on('click', '.option_reset, .option_result_button', e => {
      this.onOptionReset(e);
    }); // 옵션 필터 선택 초기화
    welContainer.on('click', '#_sortFilters .sort_review_btn', e => {
      this.onClickSortFilter(e);
    }); // 정렬 필터 선택
    welBody.on('click', '.option_default', e => {
      this.onSelectOptionDepth(e);
    }); // 옵션 타이틀 선택
    welBody.on('click', '.option_review_item', e => {
      this.onSelectOption(e);
    }); // 옵션 아이템 선택
    welBody.on('click', '.option_confirm', e => {
      this.onOptionConfirm(e);
    }); // [P] 옵션 아이템 선택 확인
    welContainer.on('click', '#showSCReview', e => {
      this.onClickSCReview(e);
    });
  }

  clearEvent() {
    $('#_reviewWrap').off('click', '.btn_review_wide');
    $('#_reviewWrap').off('click', '.close');
    $('#_reviewWrap').off('click', '[data-role=moveToBuylist]');
    $('#_reviewWrap').off('click', '[data-role=recommendReview]');
    $('#_reviewWrap').off('click', '[data-role=reportReview]');
    $('#_reviewWrap').off('click', '[data-role=callPreview]');
    $('#_reviewWrap').off('click', '[data-role=modifyReview]');
    $('#_reviewWrap').off('click', '[data-role=deleteReview]');
    $('#_reviewWrap').off('click', '[data-role=prevPhotoReviewImage]');
    $('#_reviewWrap').off('click', '[data-role=nextPhotoReviewImage]');
    $('#_reviewWrap').off('click', '[data-role=showReviewDetail]');
    $('#_reviewWrap').off('click', '#_showOnlyPhotoReview');
    $('#_reviewWrap').off('click', '.option_select_area');
    $('#_reviewWrap').off('click', '.option_reset, .option_result_button');
    $('#_reviewWrap').off('click', '#showSCReview');
    $('body').off('click', '.option_default');
    $('body').off('click', '.option_review_item');
    $('body').off('click', '.option_confirm');
    if (this.oPreviewLayer) {
      this.oPreviewLayer.clearEvent();
    }
  }

  setInfinityScroll() {
    const el = document.querySelector('.btn_review_wrap');

    if (this.io && this.io.entryList) {
      this.io.unobserve(el);
      this.io = null;
    }

    this.io = new TMON.IntersectionObserver((entry, observer) => {
      const display = document.querySelector('#review').style.display;
      if (entry.isIntersecting && display !== 'none') {
        const fn = throttle(() => {
          this.getReview();
          observer.unobserve(entry.target);
        }, 250);
        fn();
      }
    });

    this.io.observe(el);
  }

  openReviewSurvey() {
    $('.star_user_bind').toggleClass('on');
  }

  /**
   * 단계(nDepth)의 옵션 타이틀 변경하고, 선택 가능한 옵션을 다시 그림
   */
  updateOptionSelector = (nDepth, nSelectIndex = -1, updateParent = true) => {
    const {
      reviewOptionTree: {
        data: { optionTreeTitles },
      },
    } = TMON.oApp.htStorage;

    if (optionTreeTitles && optionTreeTitles.length > 0) {
      optionTreeTitles.map((sTitles, nNum) => {
        const welWrapper = $(`[data-name="reviewDepSelWrap${nNum}"]`);
        const sOptionTitle =
          typeof sTitles === 'string' ? sTitles : `옵션명${nNum}`;

        // 해당하는 단계(nDepth)의 옵션 타이틀 변경
        if (nNum === nDepth) {
          const aList = TMON.oApp.oUtil.getReviewOptionTreeChildNodesByDepth(
            nDepth,
            this.aSelectedOption.length > 1 ? this.aSelectedOption : [0]
          );

          if (nSelectIndex !== -1 && updateParent) {
            welWrapper
              .find('.option_default i')
              .html(aList[nSelectIndex].title);
          } else if (updateParent) {
            welWrapper.find('.option_default i').html(optionTreeTitles[nDepth]);
          }
          // 다음 단계의 리스트 생성 및 제목 초기화, 버튼 상태 변경
        } else if (nNum < optionTreeTitles.length && nNum === nDepth + 1) {
          const aList = TMON.oApp.oUtil.getReviewOptionTreeChildNodesByDepth(
            nDepth + 1,
            this.aSelectedOption
          );

          $(`[data-name="reviewDepSelWrap${nNum}"] > ul`).html(
            aList
              .map((htItem, nIdx) => this.getOptionItemHtml(htItem, nIdx))
              .join('')
          );

          welWrapper.removeClass('selected');
          if (nSelectIndex === -1) {
            welWrapper
              .find('.option_review_button')
              .removeAttr('disabled')
              .find('i')
              .html(sOptionTitle);
          }
          // 그 다음 Depth 전부 disabled
        } else if (nNum < optionTreeTitles.length && nNum > nDepth + 1) {
          welWrapper.removeClass('selected');
          welWrapper.find('> ul').empty();
          welWrapper
            .find('.option_review_button')
            .attr('disabled', 'disabled')
            .find('i')
            .html(sOptionTitle);
        }

        return true;
      });
    }
  };

  updateSavedOption = nDepth => {
    const aList = TMON.oApp.oUtil.getReviewOptionTreeChildNodesByDepth(
      nDepth,
      this.aSelectedOption
    );
    const currentItem =
      aList[this.aSelectedOption[this.aSelectedOption.length - 1]];

    $(`[data-name="reviewDepSelWrap${nDepth}"]`)
      .find('.option_default i')
      .html(currentItem.title);

    this.htFilterOption.tmpOptionDealNo = currentItem.dealNo;
  };

  /**
   * 옵션 항목을 선택했을 때 처리
   */
  onSelectOption = e => {
    const welCurrentTarget = $(e.currentTarget);
    const nIndex = parseInt(welCurrentTarget.data('index'), 10);
    const nDepth = welCurrentTarget.parents('ul').data('depth');

    this.aSelectedOption[nDepth] = nIndex;
    this.nCurrentDepth = nDepth;

    $('.option_review_box')
      .removeClass('on')
      .addClass('selected');

    // 마지막 뎁스가 아님
    if (
      TMON.oApp.htStorage.reviewOptionTree.data.optionTreeTitles.length !==
      nDepth + 1
    ) {
      $('.option_confirm')
        .removeClass('on')
        .attr('disabled', true);

      this.updateOptionSelector(nDepth, nIndex);

      welCurrentTarget
        .closest('.option_review_box')
        .next()
        .find('.option_default')
        .trigger('click');
      // 마지막 뎁스 - 옵션 넘버가 있으므로 저장
    } else {
      $('.option_confirm')
        .addClass('on')
        .attr('disabled', false);
      this.updateSavedOption(nDepth);
    }
  };

  /**
   * 옵션 타이틀을 선택했을 때 처리
   */
  onSelectOptionDepth = e => {
    const welCurrentTarget = $(e.currentTarget);
    const welTargetContainer = welCurrentTarget.closest('.option_review_box');
    const nCurrentIndex = welCurrentTarget.data('index');

    // 펼쳐진 상태에서 다음 단계 제목을 누름
    if (this.aSelectedOption.length < nCurrentIndex) {
      $('.option_review_box:first-child').removeClass('on');
      this.updateOptionSelector(nCurrentIndex - 1, -1, false);
      return;
    }

    // 펼쳐져 있는 상태
    if (welTargetContainer.hasClass('on')) {
      welTargetContainer.removeClass('on');
      this.updateOptionSelector(nCurrentIndex - 1, -1, false);
      return;
    }

    if (nCurrentIndex === 0) {
      this.aSelectedOption = [];
    }

    this.nCurrentDepth = nCurrentIndex;

    this.updateOptionSelector(nCurrentIndex);

    $('.option_review_box').removeClass('on');
    $('.option_select_button').removeClass('on');

    $('.option_result_wrap').hide();

    welTargetContainer.addClass('on');
  };

  /**
   * 옵션 필터 선택 초기화
   */
  onOptionReset = () => {
    this.aSelectedOption = [];
    this.htFilterOption.tmpOptionDealNo = null;
    this.htFilterOption.optionDealNo = null;

    $('.option_review_box').removeClass('on');
    $('.option_select_button').removeClass('on');
    $('.option_confirm').removeClass('on');
    $('.option_result_wrap').hide();

    this.updateOptionSelector(0, -1);

    if (TMON.oApp.sPlatform === 'PW') {
      this.getReviewByPage(1);
    } else {
      this.nPage = 0;
      this.nCount = 0;
      this.getReview(true);
    }
  };

  /**
   * 옵션 필터의 값을 선택
   */
  onOptionConfirm = () => {
    const { tmpOptionDealNo } = this.htFilterOption;

    $('.option_result_wrap .text').html(
      $.map($('.option_default'), elem =>
        $(elem)
          .text()
          .replace(/\s{2,}/g, '')
      ).join(' | ')
    );

    $('.option_select_button').addClass('on');
    $('.option_result_wrap').show();

    if (tmpOptionDealNo) {
      this.htFilterOption.optionDealNo = tmpOptionDealNo;
    }

    if (TMON.oApp.sPlatform === 'PW') {
      this.getReviewByPage(1);
    } else {
      this.nPage = 0;
      this.nCount = 0;
      this.getReview(true);
    }
  };

  onClickShowOnlyPhotoReview = () => {
    if (this.htFilterOption.flagImage === 'Y') {
      this.htFilterOption.flagImage = null;
    } else {
      this.htFilterOption.flagImage = 'Y';
    }

    if (TMON.oApp.sPlatform === 'PW') {
      this.getReviewByPage(1);
    } else {
      this.nPage = 0;
      this.nCount = 0;
      this.getReview(true);
    }
  };

  onClickShowOptionFilterLayer() {
    if (!this.oSelectReviewOptionFilterLayer) {
      this.oSelectReviewOptionFilterLayer = new SelectReviewOptionFilterLayer(
        this.aSelectedOption
      );

      this.aSelectedOption = [];
      this.nCurrentDepth = -1;
      this.updateOptionSelector(0, -1, false);

      $('[data-name=reviewDepSelWrap0]').addClass('on');
    }

    this.oSelectReviewOptionFilterLayer.open();
  }

  /**
   * 포토 리뷰 클릭시에 해쉬를 추가하도록 한다.
   * @param e
   */
  onClickViewPhotoReview(e) {
    const wel = $(e.currentTarget);
    const htHash = {
      scene: 'scene-review',
      photoReview: wel.hasClass('photo_link') ? 'review' : 'list',
    };

    if (wel.hasClass('photo_link')) {
      htHash.reviewNo = wel.attr('data-reviewNo');
    }

    TMON.util.setHashJSON(htHash);
    e.preventDefault();
  }

  onClickPrevPhotoReviewImage() {
    const welPrevBtn = $('#_reviewWrap [data-role=prevPhotoReviewImage]');
    const welItem = $('#_reviewWrap li.photo_list_item');

    if (welPrevBtn.hasClass('disabled')) {
      return;
    }

    welItem
      .eq(this.nPhotoSlideIndex + this.PHOTOREVIEW_SLIDE_IMAGE_COUNT)
      .hide();
    this.nPhotoSlideIndex -= 1;
    welItem.eq(this.nPhotoSlideIndex).show();

    this.updatePhotoReviewSlideBtnStatus();
  }

  onClickNextPhotoReviewImage() {
    const welNextBtn = $('#_reviewWrap [data-role=nextPhotoReviewImage]');
    const welItem = $('#_reviewWrap li.photo_list_item');

    if (welNextBtn.hasClass('disabled')) {
      return;
    }

    welItem.eq(this.nPhotoSlideIndex).hide();
    welItem
      .eq(this.nPhotoSlideIndex + this.PHOTOREVIEW_SLIDE_IMAGE_COUNT)
      .show();
    this.nPhotoSlideIndex += 1;

    // 다음 데이터를 불러온다.
    if (
      this.nPhotoSlideIndex + this.PHOTOREVIEW_SLIDE_IMAGE_COUNT >=
      welItem.length - 1 - this.PHOTOREVIEW_NEXT_PAGE_MARGIN_COUNT
    ) {
      this.getNextPhotoReviewData();
    }

    this.updatePhotoReviewSlideBtnStatus();
  }

  updatePhotoReviewSlideBtnStatus() {
    const welPrevBtn = $('#_reviewWrap [data-role=prevPhotoReviewImage]');
    const welNextBtn = $('#_reviewWrap [data-role=nextPhotoReviewImage]');
    const welItem = $('#_reviewWrap li.photo_list_item');

    if (
      this.nPhotoSlideIndex + this.PHOTOREVIEW_SLIDE_IMAGE_COUNT >=
      welItem.length
    ) {
      // 마지막 포토인경우
      welNextBtn.addClass('disabled').prop('disabled', true);
    } else {
      welNextBtn.removeClass('disabled').prop('disabled', false);
    }

    if (this.nPhotoSlideIndex === 0) {
      // 첫 포토인 경우
      welPrevBtn.addClass('disabled').prop('disabled', true);
    } else {
      welPrevBtn.removeClass('disabled').prop('disabled', false);
    }
  }

  afterLoginAction() {
    const sAfterLoginAction = localStorage.getItem('AFTER_LOGIN_REVIEW');
    const sReviewActionSerial = localStorage.getItem('REVIEW_ACTION_SERIAL');
    const sReviewActionMemberSerial = localStorage.getItem(
      'REVIEW_ACTION_MEMBER_SERIIAL'
    );
    const nWindowScroll = localStorage.getItem('REVIEW_SCROLL');
    this.clearLocalStorage();
    if (!TMON.bLogin) {
      return;
    }
    switch (sAfterLoginAction) {
      case 'MOVE_TO_BUYLIST':
        this.moveToBuylist();
        TMON.oApp.oUtil.scrollTop(this, nWindowScroll);
        break;
      case 'REPORT_REVIEW':
        this.openReportReviewLayer(sReviewActionSerial);
        TMON.oApp.oUtil.scrollTop(this, nWindowScroll);
        break;
      case 'RECOMMEND_REVIEW':
        this.recommendReview(sReviewActionSerial, sReviewActionMemberSerial);
        TMON.oApp.oUtil.scrollTop(this, nWindowScroll);
        break;
      case 'CANCEL_RECOMMEND_REVIEW':
        this.cancelRecommendReview(sReviewActionSerial);
        TMON.oApp.oUtil.scrollTop(this, nWindowScroll);
        break;
      case 'RECOMMENDATION_REVIEW': // 포토리뷰 보기에서 추천을 눌렀을 경우
        this.recommendationReview(sReviewActionSerial);
        TMON.oApp.oUtil.scrollTop(this, nWindowScroll);
        break;
      case 'CANCELRECOMMENDATION_REVIEW':
        this.cancelRecommendationReview(sReviewActionSerial);
        TMON.oApp.oUtil.scrollTop(this, nWindowScroll);
        break;
      default:
        break;
    }
  }

  clearLocalStorage() {
    localStorage.removeItem('REVIEW_ACTION_DEALNO');
    localStorage.removeItem('FIRST_REVIEW_ACTION_SERIAL');
    localStorage.removeItem('REVIEW_ACTION_SERIAL');
    localStorage.removeItem('REVIEW_ACTION_MEMBER_SERIIAL');
    localStorage.removeItem('AFTER_LOGIN_REVIEW');
    localStorage.removeItem('REVIEW_SCROLL');
  }

  setReview() {
    this.nPage = TMON.oApp.htStorage.reviewList.callParam.params.page;
    this.nCount = TMON.oApp.htStorage.reviewList.callParam.params.count;
    const bReplaceData = this.nPage === 1 || this.bUsePaginate;

    const {
      reviewOptionTree: {
        data: { optionTreeTitles },
      },
    } = TMON.oApp.htStorage;

    if (
      !optionTreeTitles ||
      (optionTreeTitles && optionTreeTitles.length > 3) ||
      TMON.htStaticData.htDealInfo.isScDeal
    ) {
      $('.option_select_area, .option_result_wrap, .option_review_wrap').hide();
    }

    if (
      TMON.oApp.htStorage.reviewList.data.reviewContents &&
      TMON.oApp.htStorage.reviewList.data.reviewContents.length > 0
    ) {
      this.renderReviewItems(bReplaceData);

      $('#_reviewList, #_reviewContents').show();

      $('._noContents, ._noFilteredReview, .option_review_error_text').hide();
    } else {
      $(
        '#_reviewList, #_reviewContents, ._noContents, ._noFilteredReview, .option_review_error_text, ._noReview'
      ).hide();

      if (
        this.htFilterOption.optionDealNo &&
        this.htFilterOption.optionDealNo !== '' &&
        this.htFilterOption.flagImage
      ) {
        $('._noPhotoReviewWithOption').show();
      } else if (
        this.htFilterOption.optionDealNo &&
        this.htFilterOption.optionDealNo !== ''
      ) {
        $('._noReviewWithOption').show();
      } else if (this.htFilterOption.flagImage) {
        $('._noPhotoReview').show();
      } else {
        $('._noReview').show();
      }

      $('._noContents, ._noFilteredReview').show();
    }

    this.toggleMoreButton();
  }

  // M일 경우, 더보기 눌러서 리뷰 목록을 받아올 때
  getReview(bReset = false) {
    const htParams = {};

    // 리뷰 모아보기
    htParams.bShowSCReview = this.bShowSCReviewChecked;

    if (bReset) {
      // bReset 이 true 이므로, 현재 페이지를 무시하고 첫 페이지를 불러옵니다.
      htParams.page = 1;
      htParams.count = this.FIRST_REVIEW_COUNT;
    } else if (this.nCount === this.FIRST_REVIEW_COUNT) {
      // FIRST_REVIEW_COUNT 와 현재 count 가 같으므로, page:1, count:COUNT_PER_PAGE 로 호출합니다.
      htParams.page = 1;
      htParams.count = this.COUNT_PER_PAGE;
    } else {
      // 위 상황에 모두 부합하지 않으면 다음 페이지를 불러와야 합니다.
      htParams.page = this.nPage + 1;
      htParams.count = this.COUNT_PER_PAGE;
    }

    if (
      this.htFilterOption.optionDealNo &&
      this.htFilterOption.optionDealNo !== ''
    ) {
      htParams.optionDealNo = this.htFilterOption.optionDealNo;
    }

    if (this.htFilterOption.flagImage) {
      htParams.flagImage = this.htFilterOption.flagImage;
    }

    if (this.htFilterOption.sortKey) {
      htParams.order = this.htFilterOption.sortKey;
    }

    // 분기 처리 하면 될듯
    TMON.oApp.oApi.fetchApi('reviewList', htParams);
  }

  // PW일 경우, 페이지를 눌러서 리뷰 목록을 받아올 때
  getReviewByPage(nRequestPage) {
    const htParams = {
      page: nRequestPage,
      count: this.COUNT_PER_PAGE,
    };

    // 리뷰 모아보기
    htParams.bShowSCReview = this.bShowSCReviewChecked;

    if (
      this.htFilterOption.optionDealNo &&
      this.htFilterOption.optionDealNo !== ''
    ) {
      htParams.optionDealNo = this.htFilterOption.optionDealNo;
    }

    if (this.htFilterOption.flagImage) {
      htParams.flagImage = this.htFilterOption.flagImage;
    }

    if (this.htFilterOption.sortKey) {
      htParams.order = this.htFilterOption.sortKey;
    }

    TMON.oApp.oApi.fetchApi('reviewList', htParams);
  }

  toggleOption(e) {
    $(e.currentTarget).toggleClass('on');
    e.preventDefault();
  }

  toggleMoreButton() {
    const responseCount =
      TMON.oApp.htStorage.reviewList.data.reviewContents.length;
    const totalCount = TMON.oApp.htStorage.reviewList.data.filteredTotalCount
      ? parseInt(TMON.oApp.htStorage.reviewList.data.filteredTotalCount, 10)
      : parseInt(TMON.oApp.htStorage.reviewList.data.totalCount, 10);
    const nRenderedReviewCount = $('#_reviewList > li').length;

    if (
      !this.bUsePaginate &&
      totalCount > nRenderedReviewCount &&
      responseCount !== 0
    ) {
      this.setInfinityScroll();
    }
  }

  moveToBuylist(e) {
    if (!TMON.bLogin) {
      e.preventDefault();
      localStorage.setItem('REVIEW_SCROLL', $(window).scrollTop());
      localStorage.setItem('AFTER_LOGIN_REVIEW', 'MOVE_TO_BUYLIST');
      TMON.oApp.oUtil.login();
      return;
    }

    /* eslint-disable no-underscore-dangle */
    if (TMON.oApp.sPlatform === 'MA' && TMON.app._isValidAppVersion('4.6.6')) {
      // 4.6.6 버젼 이상에서 '마이리뷰 > 미작성리뷰' 앱 네비 페이지로 랜딩되게 콜앱 작업
      TMON.app.callApp('webview', 'goMyReview');
    } else if (TMON.oApp.sPlatform === 'MA') {
      TMON.app.callApp(
        'webview',
        'showView',
        '상품리뷰',
        TMON.util.aup(TMON.htLocal.htURL.buyList, TMON.sAppQuery),
        true,
        false
      );
    }

    if (TMON.oApp.sPlatform === 'MA' && e) {
      e.preventDefault();
    }
    /* eslint-disable no-underscore-dangle */
    this.clearLocalStorage();
  }

  setPagingToLocalStorage() {
    if (TMON.oApp.sPlatform !== 'MA') {
      TMON.util.setHashJSON({ tab: TMON.oApp.htStorage.tab });
    }
  }

  recommendReview(sReviewSrl, sMemberSrl) {
    localStorage.setItem('REVIEW_SCROLL', $(window).scrollTop());
    localStorage.setItem('REVIEW_ACTION_SERIAL', sReviewSrl);
    localStorage.setItem('REVIEW_ACTION_MEMBER_SERIIAL', sMemberSrl);
    localStorage.setItem('AFTER_LOGIN_REVIEW', 'RECOMMEND_REVIEW');

    if (!TMON.bLogin) {
      this.setPagingToLocalStorage();
      TMON.oApp.oUtil.login('', '', '', this.afterLoginAction.bind(this));
    } else if (TMON.memberNo === sMemberSrl) {
      this.showRejectMessageForOwner(false);
      this.clearLocalStorage();
    } else {
      TMON.oApp.oApi.fetchApi('recommendReview', { sReviewSrl });
      this.clearLocalStorage();
    }
  }

  cbRecommendReview() {
    const recommendReview = TMON.oApp.htStorage.recommendReview.data;
    try {
      if (recommendReview.result) {
        const nTargetReviewSrl = recommendReview.review.reviewSrl;
        const nRecommendCount = recommendReview.review.recommendCnt;
        const commonInput = [nTargetReviewSrl, nRecommendCount, false];

        this.updateRecommendCount(...commonInput);
        TMON.oModuleReview.afterRecommend(...commonInput);
        alert('상품 리뷰를 추천했습니다.');
      }
    } catch (e) {
      alert('잘못된 요청입니다.');
    }
  }

  cancelRecommendReview(sReviewSrl) {
    localStorage.setItem('REVIEW_SCROLL', $(window).scrollTop());
    localStorage.setItem('REVIEW_ACTION_SERIAL', sReviewSrl);
    localStorage.setItem('AFTER_LOGIN_REVIEW', 'CANCEL_RECOMMEND_REVIEW');

    if (!TMON.bLogin) {
      this.setPagingToLocalStorage();
      TMON.oApp.oUtil.login();
    } else {
      TMON.oApp.oApi.fetchApi('cancelRecommendationReview', { sReviewSrl });
      this.clearLocalStorage();
    }
  }

  cbCancelRecommendReview() {
    const htData = TMON.oApp.htStorage.cancelRecommendationReview;
    const reviewSrl = Number(htData.htParams.sReviewSrl);
    const reviewCount = htData.data;

    try {
      const commonInput = [reviewSrl, reviewCount, true];
      this.updateRecommendCount(...commonInput);
      TMON.oModuleReview.afterRecommend(...commonInput);

      alert('리뷰 추천이 취소되었습니다.');
    } catch (e) {
      console.error(e);
    }
  }

  showRejectMessageForOwner(isPhotoReview) {
    const rejectMessage = "다른 사용자의 리뷰만 '좋아요' 할 수 있습니다.";

    if (TMON.sDevice !== 'PW') {
      if (isPhotoReview) {
        TMON.oModuleReview.showToast(rejectMessage);
      } else {
        $('[data-role=review_reject_toast]')
          .show()
          .delay(2000)
          .fadeOut('slow');
      }
    } else {
      alert(rejectMessage);
    }
  }

  updateRecommendCount(nTargetReviewSrl, nRecommendCount, bIsCancelRecommend) {
    const welRecommendButton = $(
      `[data-role=recommendReview][data-reviewsrl=${nTargetReviewSrl}]`
    );
    if (bIsCancelRecommend) {
      welRecommendButton.removeClass('on');
    } else {
      welRecommendButton.addClass('on');
    }
    welRecommendButton.find('.text').html(nRecommendCount);
  }

  openReportReviewLayerFromPhotoReview(sReviewSrl) {
    const openLayer = () => {
      if (!this.oReportLayer) {
        this.oReportLayer = new ReportLayer();
      }

      this.oReportLayer.open(sReviewSrl, 'photoReview');
      this.clearLocalStorage();
    }
    if (!TMON.bLogin) {
      localStorage.setItem('FIRST_REVIEW_ACTION_SERIAL', sReviewSrl); // 포토 리뷰 리스트에 첫번째로 와야할 리뷰번호(보고있던 리뷰에서 로그인 등으로 다른페이지 왔다가 온 경우 보고있던 리뷰를 바로 보여주기 위해 사용)
      this.setPagingToLocalStorage();
      TMON.oApp.oUtil.login('', '', '', openLayer);
    } else {
      openLayer();
    }
  }

  openReportReviewLayer(sReviewSrl) {
    const openLayer = () => {
      if (!this.oReportLayer) {
        this.oReportLayer = new ReportLayer();
      }

      this.oReportLayer.open(sReviewSrl, 'list');
      this.clearLocalStorage();
    }
    localStorage.setItem('REVIEW_SCROLL', $(window).scrollTop());
    localStorage.setItem('REVIEW_ACTION_SERIAL', sReviewSrl);
    localStorage.setItem('AFTER_LOGIN_REVIEW', 'REPORT_REVIEW');
    if (!TMON.bLogin) {
      this.setPagingToLocalStorage();
      TMON.oApp.oUtil.login('', '', '', openLayer);
    } else {
      openLayer();
    }
  }

  cbReportReview() {
    try {
      if (TMON.oApp.htStorage.reportReview.data.result) {
        /**
         * 구글 심사 UGC 정책 위반 대응
         * 신고한 리뷰는 보이지 않도록 정리합니다.
         */
        let isPhotoReview = false; // 포토리뷰 여부
        const reviewSrl = TMON.oApp.getStorage().reportReview.htParams.sReviewSrl;
        if (reviewSrl !== "")
        {
          const reviewEl = document.querySelector(`#_reviewList li[data-reviewsrl="${reviewSrl}"]`);
          if (reviewEl)
          {     
            if (document.querySelector(`#_reviewList li[data-reviewsrl="${reviewSrl}"] div.review_image`)){
              isPhotoReview = true;
            }

            reviewEl.remove();
          }          
        }

        // 포토리뷰 리스트 리로드    
        if (!isPhotoReview) {
          const photoReviewArr = [...document.querySelectorAll('ul.photo_list_wrap li')].map(
            (e) => {
                return e.getAttribute("data-reviewno");
            }
          );

          if (photoReviewArr.indexOf(reviewSrl) >= 0) {
            isPhotoReview = true;
          }      
        }
        if (isPhotoReview) {
          this.reloadPhotoReviewList(); 
        }       

        alert(
          '신고해 주셔서 감사합니다.\n신고 내용은 이용약관 및 정책에 의해 처리됩니다.'
        );
      } else {
        alert(TMON.oApp.htStorage.reportReview.data.message);
      }
    } catch (e) {
      // console.error(e);
      alert('잘못된 요청입니다.');
    }
  }

  callPreview(e) {
    const nIndex = $(e.currentTarget)
      .parent()
      .index();
    const aImageList = $(e.currentTarget)
      .closest('.review_image_list')
      .find('button')
      .map(function fn() {
        return $(this).attr('data-originsrc');
      })
      .get();

    if (!this.oPreviewLayer) {
      this.oPreviewLayer = new PreviewLayer();
    }

    this.oPreviewLayer.open(nIndex, aImageList);

    e.preventDefault();
  }

  onClickDeleteReview(e) {
    const wel = $(e.currentTarget);
    this.deleteReview(
      wel.attr('data-mainBuySrl'),
      wel.attr('data-mainDealSrl'),
      wel.attr('data-memberSrl'),
      wel.attr('data-reviewSrl')
    );
    e.preventDefault();
  }

  onClickModifyReview(e) {
    e.preventDefault();

    if (TMON.sDevice === 'PW') {
      window.location = TMON.htLocal.htURL.modifyReview;
      return;
    }

    if (TMON.oApp.sPlatform === 'MA' && !TMON.app._isValidAppVersion('4.6.9')) {
      // 4.6.9 버전 이하에서는 Android에서 파일업로드가 안되 기존 callApp을 호출한다.
      this.showReviewModifyPHPPage($(e.currentTarget).attr('data-mainBuySrl'));
      return;
    }

    const htHash = {
      scene: 'scene-review',
      photoReview: 'modify',
      reviewNo: $(e.currentTarget).attr('data-reviewsrl'),
    };

    TMON.util.setHashJSON(htHash);
  }

  /**
   * 구버전 앱에서는 기존 수정페이지(PHP)로 웹뷰를 호출한다. (기존 Android 앱에서 딜상세 페이지에서 파일 업로드가 안되는 문제)
   * @param sMainBuySrl
   */
  showReviewModifyPHPPage(sMainBuySrl) {
    const returnUrl = `return_url=${encodeURIComponent(
      TMON.htLocal.htURL.modifyReviewReturnUrl
    )}`;
    const sModifyUrl = TMON.util.aup(
      TMON.htLocal.htURL.modifyReview.replace('{mainBuySrl}', sMainBuySrl),
      TMON.sAppQuery
    );

    TMON.app.callApp(
      'webview',
      'showView',
      '상품리뷰 수정',
      TMON.util.aup(sModifyUrl, returnUrl),
      true,
      false
    );
  }

  getImageListFromReview() {
    // PC의 경우 이미지 리스틀 슬라이드 할 수 있어서 계속 추가 되어야하지만, 모바일의 경우 슬라이드가 안되기 때문에 첫 5개의 이미지만 있으면 된다.
    let aPhotoReviewData = TMON.oApp.htStorage.photoReviewList.data.list;
    if (TMON.sDevice !== 'PW') {
      // 리뷰 삭제 후 모듈에서 삭제된 리뷰가 제거된 리스트를 다시 받는다.
      aPhotoReviewData = TMON.oModuleReview.getData().length
        ? TMON.oModuleReview.getData()
        : TMON.oApp.htStorage.photoReviewList.data.list;
    }

    if (aPhotoReviewData === undefined) {
      return [];
    }

    const aImages = [];
    aPhotoReviewData.forEach(htPhotoReview => {
      htPhotoReview.imageInfo.image.forEach(img => {
        aImages.push({
          img,
          reviewNo: htPhotoReview.reviewNo,
        });
      });
    });
    return aImages;
  }

  // 정렬 필터 선택
  onClickSortFilter(e) {
    e.preventDefault();

    const sortButtons = $('#_reviewWrap #_sortFilters .sort_review_btn');
    const clickedSortButton = $(e.target);
    const clickedSortKey = $(clickedSortButton).data('sortkey');

    // 원래 선택된 필터와 현재 누른 필터가 같을 경우 아무 동작도 하지 않는다.
    if (clickedSortKey === this.htFilterOption.sortKey) {
      return;
    }

    this.htFilterOption.sortKey = clickedSortKey;
    sortButtons.removeClass('on');
    sortButtons.attr('aria-pressed', 'false');
    clickedSortButton.addClass('on');
    clickedSortButton.attr('aria-pressed', 'true');

    if (TMON.oApp.sPlatform === 'PW') {
      this.getReviewByPage(1);
    } else {
      this.nPage = 0;
      this.nCount = 0;
      this.getReview(true);
    }
  }

  render() {
    const aPhotoReviewImages = this.getImageListFromReview();
    const { filteredTotalCount } = TMON.oApp.htStorage.reviewList.data;

    const sHtml = `${this.getTotalTitleAreaHtml(
      filteredTotalCount
    )}${this.getReviewStatisticsHtml()}${
      filteredTotalCount > 0
        ? `${this.getPhotoReviewListAreaHtml(aPhotoReviewImages)}
            <section class="review_user_wrap">${this.getReviewTitleAreaHtml()}
              ${this.getNoMatchedReviewAreaHtml(filteredTotalCount)}
              ${this.getReviewContentsAreaHtml(filteredTotalCount)}
          </section>`
        : ''
    }${this.getNoContentsHtml(filteredTotalCount)}`;

    $('#_reviewWrap').html(sHtml);

    if (this.bUsePaginate) {
      this.initPaginate();
    }
  }

  getTotalTitleAreaHtml = totalCount =>
    `<div class="review_tit title_review_info">
      <h2>상품리뷰</h2>
      <span class="count">총 <em>${TMON.util.numberWithComma(
        totalCount
      )}</em>개</span>
      <ul class="review_info_list">
        <li class="item">이 상품으로 받을 수 있는 리뷰 적립금은 <span class="point_color">10원</span>입니다.</li>
      </ul> ${
        TMON.oApp.sPlatform === 'PW' && totalCount > 0
          ? `<div class="regist_btn_area"><a href="${TMON.htLocal.htURL.buyList}" data-tlarea="PCI0" data-tlord="6" data-role="moveToBuylist" class="btn btn_arr gray">리뷰 작성하기</a></div>`
          : ''
      } ${
      TMON.oApp.sPlatform !== 'PW'
        ? `<div class="no_ct_txt"><a href="${TMON.htLocal.htURL.buyList}" data-tlarea="PCI0" data-tlord="6" class="btn_write_go" data-role="moveToBuylist">이 상품을 구매했다면? <span>리뷰쓰기</span></a></div>`
        : ''
    } ${
      TMON.htStaticData.htDealInfo.isScDeal
        ? `<div class="option_checkbox">
          <input type="checkbox" name="showSCReview" id="showSCReview" class="option_checkbox_input" ${
            this.bShowSCReviewChecked ? 'checked' : ''
          }>
          <label for="showSCReview" class="option_checkbox_label">
            <span class="ico_checkbox">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="22" viewBox="0 0 22 22">
                <defs>
                    <path id="a" d="M9.51 14.206L17.624 6 19 7.401 9.51 17 3 10.414l1.377-1.401z"></path>
                </defs>
                <g fill="none" fill-rule="evenodd">
                  <path d="M0 0h22v22H0z"></path>
                  <use fill="#FFF" fill-rule="nonzero" xlink:href="#a"></use>
                </g>
              </svg>
            </span>
            <span class="option_checkbox_text">동일상품 리뷰 모아보기</span>
          </label>
        </div>`
        : ''
    }
    </div>`;

  getReviewStatisticsHtml = () => {
    const {
      dealAveragePoint,
      deliveryAveragePoint,
      filteredTotalCount,
    } = TMON.oApp.htStorage.reviewList.data;

    const {
      reviewSurveyStatistics: {
        data: { surveyInfoStatistics },
      },
    } = TMON.oApp.htStorage;

    const {
      reviewFixSurveyStatistics: {
        data: { surveyInfoStatistics: fixSurveyInfoStatistics },
      },
    } = TMON.oApp.htStorage;

    return `<section class="star_score_wrap">
                <h1 class="blind">상품 리뷰 통계</h1>
                <div class="star_score_box">
                    <div class="star_score_bind">${this.getScoreStatisticsHtml(
                      '상품 만족도',
                      dealAveragePoint.toFixed(1),
                      filteredTotalCount,
                      !TMON.htStaticData.bIsDeliveryDeal ? 'type2' : ''
                    )} ${
      TMON.htStaticData.bIsDeliveryDeal
        ? this.getScoreStatisticsHtml(
            '배송 만족도',
            deliveryAveragePoint.toFixed(1),
            filteredTotalCount
          )
        : ''
    }</div> ${
      !this.bShowSCReviewChecked &&
      ((surveyInfoStatistics && surveyInfoStatistics.length > 0) ||
        (fixSurveyInfoStatistics && fixSurveyInfoStatistics.length > 0))
        ? this.getSurveyStatisticsHtml(
            surveyInfoStatistics,
            fixSurveyInfoStatistics
          )
        : ''
    }
                </div>
            </section>`;
  };

  getScoreStatisticsHtml = (
    title,
    reviewAvgScore,
    reviewCount,
    wrapperClass = ''
  ) =>
    `<div class="star_rate_wrap ${
      wrapperClass /* 별이 옆에 있는 'type2'가 있음 */
    }">
            <span class="star_rate_bind">
                <span class="text">${title}</span>
                <div class="grade_average" aria-label="구매후기 5점 만점 중 ${reviewAvgScore}점 ${reviewCount}명 참여">
                    <div class="grade_average_points" tabIndex="-1">
                        ${Array.from(
                          { length: 5 },
                          (x, i) =>
                            `<span class="grade_average_point">
                                <span
                                    class="${
                                      reviewAvgScore < i
                                        ? 'grade_average_mark '
                                        : `grade_average_mark mark_${
                                            reviewAvgScore >= i + 1
                                              ? 100
                                              : ((reviewAvgScore * 10) % 10) *
                                                10
                                          }`
                                    }"
                                ></span>
                            </span>`
                        ).join('')}
                    </div>
                </div>
            </span>
            <span class="star_rate_num">${reviewAvgScore}</span>
        </div>`;

  /* eslint max-lines: 0 */
  getSurveyStatisticsHtml = (surveyInfoStatistics, fixSurveyInfoStatistics) =>
    `<div class="star_user_bind">
      <span class="star_user_title">사용 만족도</span>
      <ul class="keyword_bar_list">
        ${
          surveyInfoStatistics && surveyInfoStatistics.length > 0
            ? this.getSurveyStatisticsSummaryHtml(surveyInfoStatistics)
            : ''
        }
        ${
          fixSurveyInfoStatistics && fixSurveyInfoStatistics.length > 0
            ? this.getSurveyStatisticsSummaryHtml(fixSurveyInfoStatistics)
            : ''
        }
      </ul>
      <div class="star_keyword_bind">
        ${
          surveyInfoStatistics && surveyInfoStatistics.length > 0
            ? this.getSurveyStatisticsListHtml(surveyInfoStatistics)
            : ''
        }
        ${
          fixSurveyInfoStatistics && fixSurveyInfoStatistics.length > 0
            ? this.getSurveyStatisticsListHtml(fixSurveyInfoStatistics)
            : ''
        } 
      </div>
      <button type="button" class="btn_review_wide">
        <span class="text">자세히 보기</span>
        <svg width="11px" height="6px" viewBox="0 0 11 6" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="ico_arrow"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="btn_open" fill="#B7BFC8" fill-rule="nonzero"><polygon transform="translate(5.500000, 3.000000) rotate(-180.000000) translate(-5.500000, -3.000000) " points="5.5 1.4 0.723 6 0 5.3 4.777 0.7 5.5 0 11 5.3 10.277 6"></polygon></g></g></svg>
      </button>
    </div>`;

  getSurveyStatisticsSummaryHtml = surveyInfoStatistics =>
    surveyInfoStatistics
      .map(item => {
        // rate가 가장 높은 선택지를 선택
        const representSelection = item.selections.reduce(
          (previous, current) => {
            let retItem = null;

            // rate가 동률일 경우 우선순위가 높은 선택지를 반환
            if (previous.rate === current.rate) {
              retItem =
                previous.statisticsPriority > current.statisticsPriority
                  ? current
                  : previous;

              retItem.isRepresent = true;

              return retItem;
            }

            retItem = previous.rate < current.rate ? current : previous;

            retItem.isRepresent = true;

            return retItem;
          }
        );

        return `<li class="keyword_bar_item">
                        <div class="keyword_bar_wrap">
                            <span class="keyword_bar_label">${item.keyword}</span>
                            <span class="text">"${representSelection.selection}"</span>
                            <span class="unit">${representSelection.rate}%</span>
                        </div>
                    </li>`;
      })
      .join('');

  getSurveyStatisticsListHtml = surveyInfoStatistics =>
    surveyInfoStatistics
      .map(
        item =>
          `<div class="star_keyword_box">
                    <span class="q_title">
                        <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="ico_q"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="ico_q"><g><circle id="Oval" fill="#848C95" cx="9" cy="9" r="9"></circle><text id="Q" font-family="GothamBold, Gotham Bold" font-size="12" font-weight="bold" letter-spacing="-0.32" fill="#FFFFFF"><tspan x="4" y="13">Q</tspan></text></g></g></g></svg>
                        <span class="text">${getPreviewQuestionHtml(
                          item.keyword
                        )}</span>
                    </span>
                    ${item.selections
                      .map(
                        selectionItem =>
                          `<div class="percent_bar_wrap ${
                            selectionItem.isRepresent ? 'on' : ''
                          }">
                                    <span class="text">${
                                      selectionItem.selection
                                    }</span>
                                    <span class="percent_bar">
                                        <span class="progress" style="width: ${
                                          selectionItem.rate
                                        }%"></span>
                                    </span>
                                    <span class="unit">${
                                      selectionItem.rate
                                    }%</span>
                                </div>`
                      )
                      .join('')}
                </div>`
      )
      .join('');

  getPhotoReviewImageCount = photoReviewImageCount =>
    `<span class="count">총 <em>${TMON.util.numberWithComma(
      photoReviewImageCount.data
    )}</em>개</span>`;

  /**
   * 포토 리뷰 리스트
   */
  getPhotoReviewListAreaHtml = aPhotoReviewImages =>
    aPhotoReviewImages.length > 0
      ? `<section id="_photoArea" class="photo_review_wrap">
            <div class="review_tit title_review_photo">
                <h2>포토 리뷰</h2>
                ${
                  TMON.oApp.htStorage.photoReviewImageCount &&
                  $.isNumeric(TMON.oApp.htStorage.photoReviewImageCount.data)
                    ? this.getPhotoReviewImageCount(
                        TMON.oApp.htStorage.photoReviewImageCount
                      )
                    : ''
                }
            </div>
            <div class="photo_review_area">
                <div class="review_container">
                    <ul data-role="photoReviewListWrap" class="photo_list_wrap">
                        ${this.getPhotoReviewSliderHtml(false)}
                    </ul>
                </div>
                ${
                  TMON.oApp.sPlatform === 'PW'
                    ? `<button data-tlarea="PCI0" data-tlord="13" data-role="prevPhotoReviewImage" type="button" class="btn_review prev disabled" disabled style="display:${
                        aPhotoReviewImages.length >
                        this.PHOTOREVIEW_SLIDE_IMAGE_COUNT
                          ? 'block'
                          : 'none'
                      }">이전 슬라이드</button>
                    <button  data-tlarea="PCI0" data-tlord="14" data-role="nextPhotoReviewImage" type="button" class="btn_review next" style="display:${
                      aPhotoReviewImages.length >
                      this.PHOTOREVIEW_SLIDE_IMAGE_COUNT
                        ? 'block'
                        : 'none'
                    }">디음 슬라이드</button>`
                    : ''
                }
            </div>
        </section>`
      : '';

  getPhotoReviewSliderHtml = bIsAddMoreData => {
    let aPhotoReviewImages = this.getImageListFromReview();
    const nPhotoImageCount = aPhotoReviewImages.length;
    if (TMON.oApp.sPlatform !== 'PW') {
      aPhotoReviewImages = aPhotoReviewImages.slice(
        0,
        this.PHOTOREVIEW_SLIDE_IMAGE_COUNT
      );
    }

    return aPhotoReviewImages
      .map(
        (htPhotoReviewImage, nIndex) =>
          `<li class="photo_list_item ${
            nIndex >= this.PHOTOREVIEW_SLIDE_IMAGE_COUNT - 1 &&
            nPhotoImageCount > this.PHOTOREVIEW_SLIDE_IMAGE_COUNT
              ? 'more'
              : ''
          }" style="${
            bIsAddMoreData === true ||
            nIndex > this.PHOTOREVIEW_SLIDE_IMAGE_COUNT - 1
              ? 'display:none'
              : ''
          }" data-reviewNo="${htPhotoReviewImage.reviewNo}">
                    <a href="#scene=scene-review&photoReview=review&reviewNo=${
                      htPhotoReviewImage.reviewNo
                    }" data-tlarea="PCI0" data-tlord="7" class="photo_link" data-role="showReviewDetail" data-reviewNo="${
            htPhotoReviewImage.reviewNo
          }">
                        <img src="http://storage.tmon.co.kr/thumbs/image?w=300&h=300&url=${encodeURI(
                          htPhotoReviewImage.img
                        )}" onerror="this.parentNode.className='photo_link error'">
                    </a>
                    ${
                      nIndex >= this.PHOTOREVIEW_SLIDE_IMAGE_COUNT - 1 &&
                      nPhotoImageCount > this.PHOTOREVIEW_SLIDE_IMAGE_COUNT &&
                      TMON.oApp.sPlatform !== 'PW'
                        ? `
                        <a href="#scene=scene-review&photoReview=list" data-tlarea="PCI0" data-tlord="8" class="view_all" data-role="showReviewDetail"><span class="text"><i class="ico_plus"></i>더보기</span></a>
                    `
                        : ''
                    }
                </li>`
      )
      .join('');
  };

  getOptionItemHtml = (htItem, nIdx) =>
    `<li class="option_review_item" data-index="${nIdx}" data-optionno="${htItem.dealNo}">
            <button type="button" class="option_review_button option_item">${htItem.title}</button>
        </li>`;

  /**
   * 옵션별 리뷰 보기를 위한 리뷰를 가진 옵션을 선택하는 셀렉터를 초기화
   */
  getOptionSelectorHtml = () => {
    const {
      reviewOptionTree: {
        data: { optionTreeTitles },
      },
    } = TMON.oApp.htStorage;

    // 단계별 구매하기 옵션 제목
    const aOptionTitles = optionTreeTitles;
    // 반환할 html 문자열
    let sHtml = '';

    if (!aOptionTitles || aOptionTitles.length < 1) {
      return '';
    }

    // 단계별 제목 및 리스트 render
    aOptionTitles.map((sTitle, nNum) => {
      // 옵션 변경 가능 여부
      let bChangeable = false;

      if (this.aSelectedOption.length > 1 && this.aSelectedOption === nNum) {
        bChangeable = true;
      } else if (nNum === 0) {
        bChangeable = true;
      }

      sHtml += `<!-- [D] 옵션 클릭시 on 클래스 추가 -->
                <div class="option_review_box" data-name="reviewDepSelWrap${nNum}">
                    <!-- 리뷰옵션 버튼 -->
                    <button type="button" class="option_review_button option_default" data-index="${nNum}"${
        nNum !== 0 ? ' disabled' : ''
      }>
                        <i>${sTitle}</i><span class="ico_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6"><path fill="#939DA7" fill-rule="evenodd" d="M4.5 6L9 0H0z"></path></svg></span>
                    </button>
                    <!-- 리뷰옵션 리스트 -->
                    <ul data-depth="${nNum}" class="option_review_list">${
        bChangeable
          ? TMON.oApp.oUtil
              .getReviewOptionTreeChildNodesByDepth(
                nNum,
                this.aSelectedOption.length > 1
                  ? this.aSelectedOption.aIndexList
                  : [0]
              )
              .map((htItem, nIdx) => this.getOptionItemHtml(htItem, nIdx))
              .join('')
          : ''
      }</ul>
                </div>`;

      return null;
    });

    return sHtml;
  };

  getReviewTitleAreaHtml = () =>
    `<div class="review_tit title_review_all">
            <h2>리뷰 전체</h2>
            ${
              TMON.oApp.sPlatform === 'PW'
                ? `<div class="review_tit_sort">
                    <div class="sort_review">
                        <ul class="sort_review_list" id="_sortFilters">
                            <li class="sort_review_item">
                                <button type="button" class="sort_review_btn on" aria-pressed="true" data-sortkey="NEW">최신순</button>
                            </li>
                            <li class="sort_review_item">
                                <button type="button" class="sort_review_btn" aria-pressed="false" data-sortkey="RECOMMEND">좋아요순</button>
                            </li>
                            <li class="sort_review_item">
                                <button type="button" class="sort_review_btn" aria-pressed="false" data-sortkey="SCORE">별점 높은순</button>
                            </li>
                        </ul>
                    </div>
                </div>`
                : ''
            }
            <div class="review_tit_option">
                <!-- 포토리뷰 체크박스 -->
                <div class="option_checkbox">
                    <input type="checkbox" name="_showOnlyPhotoReview"  id="_showOnlyPhotoReview" class="option_checkbox_input">
                    <label for="_showOnlyPhotoReview" class="option_checkbox_label">
                        <span class="ico_checkbox"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g fill="none" fill-rule="evenodd"><path d="M0 0h20v20H0z"></path><path stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.625 9l4.276 5.13M9 14l7-8"></path></g></svg></span>
                        <span class="option_checkbox_text">포토리뷰</span>
                    </label>
                </div>
                ${
                  TMON.oApp.sPlatform !== 'PW'
                    ? `<div class="option_select_area">
                        <button type="button" class="option_select_button">
                            <span class="ico_option"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18"><g fill="none" fill-rule="evenodd" stroke="#C2C7CD" transform="rotate(90 10 10)"><path d="M7 3h11M0 3h3M15 10h3M0 10h11M7 17h11M0 17h3"></path><circle cx="13" cy="10" r="2.5"></circle><circle cx="5" cy="3" r="2.5"></circle><circle cx="5" cy="17" r="2.5"></circle></g></svg></span>
                            <span class="text">옵션별</span>
                        </button>
                    </div>`
                    : ''
                }
            </div>
            ${
              TMON.oApp.sPlatform !== 'PW'
                ? `<div class="option_result_wrap" style="display: none;">
                    <strong class="option_result_title">선택옵션</strong>
                    <p class="option_result_text"><span class="text"></span></p>
                    <button type="button" class="option_result_button" aria-label="선택옵션취소">
                        <span class="ico_close"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11"><path fill="#939DA7" fill-rule="evenodd" d="M10.267 0L11 .733 6.233 5.5 11 10.267l-.733.733L5.5 6.233.733 11 0 10.267 4.766 5.5 0 .733.733 0 5.5 4.767 10.267 0z"></path></svg></span>
                    </button>
                </div>`
                : ''
            }
            ${
              TMON.oApp.sPlatform !== 'PW'
                ? `<div class="review_tit_sort">
                    <div class="sort_review">
                        <ul class="sort_review_list" id="_sortFilters">
                            <li class="sort_review_item">
                                <button type="button" class="sort_review_btn on" aria-pressed="true" data-sortkey="NEW">최신순</button>
                            </li>
                            <li class="sort_review_item">
                                <button type="button" class="sort_review_btn" aria-pressed="false" data-sortkey="RECOMMEND">좋아요순</button>
                            </li>
                            <li class="sort_review_item">
                                <button type="button" class="sort_review_btn" aria-pressed="false" data-sortkey="SCORE">별점 높은순</button>
                            </li>
                        </ul>
                    </div>
                </div>`
                : ''
            }
        </div>`;

  getNoMatchedReviewAreaHtml = totalCount =>
    `<div class="_noContents"${totalCount >= 1 ? ' style="display: none"' : ''}>
            <div class="_noFilteredReview">
                <div class="option_review_error">
                    <p class="_noPhotoReviewWithOption option_review_error_text" style="display: none">선택하신 옵션의 포토리뷰가 없습니다.<br>다른 옵션으로 조회해 주세요.</p>
                    <p class="_noReviewWithOption option_review_error_text" style="display: none">선택하신 옵션의 리뷰가 없습니다.<br>다른 옵션으로 조회해 주세요.</p>
                    <p class="_noPhotoReview option_review_error_text" style="display: none">등록된 포토리뷰가 없습니다.<br>일반 리뷰 목록에서 리뷰를 확인해 주세요.</p>
                </div>
            </div>
        </div>`;

  getReviewContentsAreaHtml = () =>
    `<div id="_reviewContents">
            ${
              TMON.oApp.sPlatform === 'PW'
                ? `<div class="option_review_wrap">
                    <div class="option_review_inner">
                        <div class="option_review_box_wrap">${this.getOptionSelectorHtml()}</div>
                    </div>
                    <div class="option_review_button_area">
                        <!-- 리셋 버튼 -->
                        <button type="button" class="option_review_button option_reset" aria-label="새로고침"><span class="ico_reset"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><g fill="none" fill-rule="evenodd" stroke="#959EA8"><path stroke-width=".944" d="M17.472 8.972a8.5 8.5 0 1 1-1.026-4.052"></path><path d="M16.8.972v4h-4"></path></g></svg></span></button>
                        <!-- 조회 버튼 -->
                        <!-- [D]  비활성화 일때 disabled, 조회 버튼 활성화시 on 클래스 추가 -->
                        <button type="button" class="option_review_button option_confirm" disabled>조회</button>
                    </div>
                </div>`
                : ''
            }
            <ul id="_reviewList" class="review_block_list"></ul>
            ${
              this.bUsePaginate === true
                ? `<div class="ct_wrp" data-role="paginate-wrap" id="${this.sPaginateId}"></div>`
                : `<div class="ct_wrp">
                    <div class="btn_review_wrap"></div>
                </div>`
            }
        </div>`;

  getRecommendButtonHtml = review =>
    `<button type="button" data-role="recommendReview" 
      class="btn_review_thumbs ${review.isRecommended ? 'on' : ''}" 
      data-reviewsrl="${review.reviewSrl}" 
      data-membersrl=${review.memberSrl}
      data-tlarea="PCI0" data-tlord="3">
        <svg width="12px" height="14px" viewBox="0 0 12 14" version="1.1" xmlns="http://www.w3.org/2000/svg" 
        xmlns:xlink="http://www.w3.org/1999/xlink" class="ico_recommend">
          <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="ico_recommend_off">
              <g>
                <rect id="area" x="0" y="0" width="12" height="14"></rect>
                <path d="M4,12 L1.707,12 C1.31666667,12 1,11.6833333 1,11.293 L1,5.707 C1,5.31666667 1.31666667,5 1.707,5 L4,5 L4,12 Z"
                  id="Stroke-1" stroke="#6C7580"></path><path d="M9.09090909,5.4 L7.45577273,5.4 C7.37177273,5.4 7.32468182,5.31011429
                  7.36763636,5.23845714 C7.61295455,4.82925714 7.81818182,3.76665714 7.81818182,3.51428571 L7.81818182,2.88571429 
                  C7.81818182,2.57142857 7.5,1 6.54545455,1 C5.27272727,1 5.27272727,2.88571429 5.27272727,2.88571429 L5.27272727,3.51428571 
                  C5.27272727,4.45714286 4,5.4 4,5.4 L4,10.4285714 C4,11.2963143 4.71209091,12 5.59090909,12 L8.45454545,12 C9.86027273,12 
                  11,10.8742286 11,9.48571429 L11,7.28571429 C11,6.24448571 10.1450455,5.4 9.09090909,5.4 Z" id="Stroke-3" stroke="#6C7580" 
                  stroke-linecap="round" stroke-linejoin="round"></path>
              </g>
            </g>
          </g>
        </svg>
      <span class="text">${review.recommendCnt}${
      review.recommendCnt >= 999 ? '+' : ''
    }</span>
    </button>`;

  getRenderedReviewHtml(aData) {
    const reviewType = TMON.oApp.htStorage.reviewType.data;

    return aData
      .map(
        item =>
          `<li class="review_block_item" data-reviewsrl="${item.reviewSrl}">
                    <div class="review_block">
                        ${/* 상품 별점 */ ''}
                        <div class="review_block_rate">
                            <div class="review_block_star">
                                <span class="text">상품</span>
                                <span class="star_rate">
                                    <span class="star_progress_bar" style="width: ${(item.dealGpoint *
                                      100) /
                                      5}%;">
                                        <span class="blind">상품 평점 ${
                                          item.dealGpoint
                                        }</span>
                                    </span>
                                </span>
                            </div> ${
                              TMON.htStaticData.bIsDeliveryDeal
                                ? `<div class="review_block_star">
                                <span class="text">배송</span>
                                <span class="star_rate">
                                    <span class="star_progress_bar" style="width: ${(item.deliveryGpoint *
                                      100) /
                                      5}%;">
                                        <span class="blind">배송 평점 ${
                                          item.deliveryGpoint
                                        }점</span>
                                    </span>
                                </span>
                            </div>`
                                : ''
                            } </div>
                        ${/* 태그 */ ''}
                        <div class="review_tag">${
                          item.reviewSurveyList &&
                          item.reviewSurveyList.length > 0
                            ? item.reviewSurveyList.map(
                                reviewSurveyListItem =>
                                  `<span class="review_tag_label">#${reviewSurveyListItem.keyword} - ${reviewSurveyListItem.selection}</span>`
                              )
                            : ''
                        }</div>
                        <div class="review_tag">${
                          item.reviewSurveyFixItemList &&
                          item.reviewSurveyFixItemList.length > 0
                            ? item.reviewSurveyFixItemList.map(
                                reviewSurveyListItem =>
                                  `<span class="review_tag_label">#${reviewSurveyListItem.keyword} - ${reviewSurveyListItem.selection}</span>`
                              )
                            : ''
                        }</div>
                          ${
                            /* 상품 딜 옵션 */
                            item.buyOptionList && item.buyOptionList.length > 0
                              ? `<div class="button_list_box close">
                            <span class="blind">상품 옵션</span>
                            ${
                              item.buyOptionList.length > 1
                                ? // 옵션이 두개 이상 노출될 경우 button.button_list
                                  `<button type="button" class="_optionList button_list" aria-label="옵션 딜 더보기">
                                        <span class="text">${
                                          item.buyOptionList[0].optionTitle
                                        }</span>
                                        <svg width="11px" height="6px" viewBox="0 0 11 6" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="ico_arrow"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="btn_open" fill="#B7BFC8" fill-rule="nonzero"><polygon transform="translate(5.500000, 3.000000) rotate(-180.000000) translate(-5.500000, -3.000000) " points="5.5 1.4 0.723 6 0 5.3 4.777 0.7 5.5 0 11 5.3 10.277 6"></polygon></g></g></svg>
                                    </button>
                                    <div class="button_list_bind">
                                        ${item.buyOptionList
                                          .map((buyOptionItem, idx) =>
                                            idx !== 0
                                              ? `<span class="button_list_text">${buyOptionItem.optionTitle}</span>`
                                              : ''
                                          )
                                          .join('')}
                                    </div>`
                                : // 옵션이 한 개만 노출될 경우 p.button_list
                                  `<p class="button_list">
                                        <span class="text">${item.buyOptionList[0].optionTitle}</span>
                                    </p>`
                            }
                        </div>`
                              : ''
                          }
                        ${
                          /* 리뷰 텍스트 */
                          reviewType !== 'S'
                            ? `<div class="review_block_text">
                                <div class="review_text">${item.contents}</div>
                            </div>`
                            : ''
                        }
                        ${
                          /* 이미지 리스트 */
                          item.imageUseYn === 'Y' &&
                          reviewType !== 'S' &&
                          item.imageList
                            ? `<div class="review_image">
                                <ul class="review_image_list">${item.imageList
                                  .map(
                                    sImage =>
                                      `<li class="review_image_item">
                                            <button type="button" class="review_image_box" aria-label="이미지 상세보기" data-tlarea="PCI0" data-tlord="5" data-role="callPreview" data-originsrc="${
                                              TMON.htStaticData.sImgCdn
                                            }${
                                        sImage.substr(0, 1) === '/'
                                          ? sImage
                                          : `/${sImage}`
                                      }"> ${
                                        TMON.oApp.htStorage.htStaticData
                                          .useThumbnail
                                          ? `<img src="http://storage.tmon.co.kr/thumbs/image?w=300&h=300&url=${
                                              TMON.htStaticData.sImgCdn
                                            }${
                                              sImage.substr(0, 1) === '/'
                                                ? sImage
                                                : `/${sImage}`
                                            }" alt="리뷰 이미지" onError="$(this).parent().parent().addClass('onError'); $(this).parent().remove();">`
                                          : `<img src="${
                                              TMON.htStaticData.sImgCdn
                                            }${
                                              sImage.substr(0, 1) === '/'
                                                ? sImage
                                                : `/${sImage}`
                                            }" alt="리뷰 이미지" onError="$(this).parent().parent().addClass('onError'); $(this).parent().remove();">`
                                      }</button>
                                        </li>`
                                  )
                                  .join('')}</ul>
                                ${
                                  TMON.oApp.sPlatform === 'PW'
                                    ? this.getThumbNum(item.imageList.length)
                                    : ''
                                }
                            </div>`
                            : ''
                        }
                        ${/* 그 외의 리뷰 정보 */ ''}
                        <ul class="type_bar_list">
                            <li class="type_bar_item">${item.whoUpdate}</li>
                            <li class="type_bar_item">${item.createDt.substring(
                              0,
                              10
                            )} <span class="type_bar_text">작성</span></li>
                            ${
                              item.ownArticle === true
                                ? `<li class="type_bar_item">
                                        <a href="#scene=scene-review&photoReview=modify&reviewNo=${
                                          item.reviewSrl
                                        }" data-mainBuySrl="${
                                    item.mainBuySrl
                                  }" data-reviewsrl="${
                                    item.reviewSrl
                                  }" class="btn_type_bar" data-role="modifyReview">수정</a>
                                    </li>
                                    <li class="type_bar_item">
                                        <a href="#" data-reviewSrl="${
                                          item.reviewSrl
                                        }" data-mainBuySrl="${
                                    item.mainBuySrl
                                  }" data-mainDealSrl="${
                                    item.mainDealSrl
                                  }" data-memberSrl="${
                                    item.memberSrl
                                  }" class="btn_type_bar" data-role="deleteReview">삭제</a>
                                    </li>
                                    ${
                                      TMON.sDevice !== 'PW'
                                        ? `<li class="type_bar_thumb_item"> ${this.getRecommendButtonHtml(
                                            item
                                          )} </li>`
                                        : ''
                                    }`
                                : `${
                                    TMON.sDevice !== 'PW'
                                      ? `<li class="type_bar_thumb_item"> ${this.getRecommendButtonHtml(
                                          item
                                        )} </li>`
                                      : ''
                                  }
                                <li class="type_bar_item">
                                        <button type="button" class="btn_type_bar" data-role="reportReview" data-reviewsrl="${
                                          item.reviewSrl
                                        }" data-tlarea="PCI0" data-tlord="4">신고</button>
                                    </li>`
                            }
                        </ul>
                        ${
                          /*
                            리뷰 추천하기
                            btn_review_thumbs 버튼 활성화 시 on 추가
                        */ ''
                        }
                        ${
                          TMON.sDevice === 'PW'
                            ? this.getRecommendButtonHtml(item)
                            : ''
                        }
                        <div data-role="review_reject_toast" class="review_toast_recommend" style="display:none;">
                          <p class="text">다른 사용자의 리뷰만 '좋아요' 할 수 있습니다.</p>
                        </div>
                    </div>
                </li>`
      )
      .join('');
  }

  renderReviewItems(bReplaceData) {
    const { reviewContents } = TMON.oApp.htStorage.reviewList.data;
    const sHtml = this.getRenderedReviewHtml(reviewContents);

    if (bReplaceData) {
      $('#_reviewList').html(sHtml);
    } else {
      $('#_reviewList').append(sHtml);
    }

    $('#_reviewWrap .onError').each(wel => {
      this.setThumbNum(wel);
    });
  }

  setThumbNum(wel) {
    const nLength = wel.find('[data-role=callPreview]').length;
    wel.find('span.review_image_number').replace(this.getThumbNum(nLength));
  }

  getThumbNum(nLength) {
    let sHtml = '';
    if (nLength > 1) {
      sHtml = `<span class="review_image_number"><em>${nLength}</em></span>`;
    }
    return sHtml;
  }

  getNoContentsHtml = totalCount =>
    `<div class="_noContents"${totalCount >= 1 ? ' style="display: none"' : ''}>
            <div class="_noReview no_ct_txt"${
              totalCount >= 1 ? ' style="display: none"' : ''
            }>
                <p class="btn_write_go">
                    아직 작성된 리뷰가 없습니다.<br>
                    ${
                      TMON.oApp.sPlatform === 'PW'
                        ? `이 상품에 첫 번째 리뷰를 작성해 주세요.
                        <span class="point_color">리뷰를 작성하면 적립금을 드립니다.</span>`
                        : ''
                    }
                </p>
                <a href="${
                  TMON.htLocal.htURL.buyList
                }" class="btn_go" data-role="${'moveToBuylist'}" data-tlarea="PCI8" data-tlord="1">상품리뷰 작성하기</a>
            </div>
        </div>`;

  initPaginate = () => {
    this.oPaginate = new Paginate({
      welPaginate: $(`#${this.sPaginateId}`),
      sTlcode: 'PCIABT',
    });
    this.oPaginate.init({
      onClickNumber: e => {
        this.getReviewByPage(Number($(e.currentTarget).attr('data-num')));
        window.scrollTo(
          0,
          $('.review_user_wrap').offset().top -
            $('.tab-navigation').height() -
            parseInt($('.photo_review_area').css('margin-bottom') || 0, 10)
        );
        e.preventDefault();
      },
    });
  };

  updatePaginate = () => {
    if (this.oPaginate) {
      const totalCount = TMON.oApp.htStorage.reviewList.data.filteredTotalCount
        ? parseInt(TMON.oApp.htStorage.reviewList.data.filteredTotalCount, 10)
        : parseInt(TMON.oApp.htStorage.reviewList.data.totalCount, 10);
      this.oPaginate.update({
        nPageOnBlock: this.COUNT_PAGE_ON_BLOCK,
        nActivatePage: parseInt(
          TMON.oApp.htStorage.reviewList.callParam.params.page,
          10
        ),
        nTotalArticle: totalCount,
        nArticleOnPage: this.COUNT_PER_PAGE,
      });
    }
  };
}
